#== Description
# This widget adds simple CSS class toggling on a radio button's label so
# that it can easily be styled when focused or checked.
#
# == Behaviour
# - toggles a 'radio-checked' CSS class on the label when the radio button is
#   checked/unchecked
# - toggles a 'radio-focused' CSS class on the label when focus is set
#   on the radio button
# - updates the label's initial checked state just in case the markup does not
#   reflect the current state of the input
# - updates the label's checked state when the question is made visible. This is
#   necessary as inputs are usually reset when hidden

require('bijou/base')

"use strict"

$.widget "chopin.radiobutton", $.bijou.base,
  _create: ->
    @label = @element.closest("label")
    @allLabels = @element.closest(".control").find("label")

    @_on
      "click": ->
        @allLabels.removeClass("radio-checked")
        @update()
      "focusin": ->
        @label.addClass("radio-focused")
      "focusout": ->
        @label.removeClass("radio-focused")

    @_on @element.closest(".control-block"),
      "questionShow": -> @update()

    # Help IE8 with clicks on images
    @_on @label.find("img"),
      "click": (e) ->
        @element.prop("checked", true) unless @element.prop("checked")
        @element.trigger("click")

    @update()

  update: ->
    @label.toggleClass("radio-checked", @element.prop("checked"))
